import { render, staticRenderFns } from "./message-details-schedule-block.vue?vue&type=template&id=1f729ad2&scoped=true"
import script from "./message-details-schedule-block.vue?vue&type=script&lang=js"
export * from "./message-details-schedule-block.vue?vue&type=script&lang=js"
import style0 from "./message-details-schedule-block.vue?vue&type=style&index=0&id=1f729ad2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f729ad2",
  null
  
)

export default component.exports